<template>
  <div class="page page-add">
    <div class="page-container">
      <transition name="slide-fade" mode="out-in">
        <template v-if="currentStep == 0">
          <div>
            <div class="page-title">新增定额捐款</div>
            <div class="v-px-md v-mt-lg">
              <a-form-model ref="form" :model="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
                <div class="panel">
                  <div class="panel-body">
                    <a-row :gutter="0">
                      <a-col span="12">
                        <a-form-model-item :colon="false" prop="paymentName">
                          <span slot="label">
                            <i class="required-mark">*</i>
                            摘要
                          </span>
                          <a-input placeholder="摘要" allowClear v-model="form.paymentName" ref="paymentName" />
                        </a-form-model-item>
                      </a-col>
                      <a-col span="12">
                        <a-form-model-item :colon="false" prop="contractDate">
                          <span slot="label">
                            <i class="required-mark">*</i>
                            协议日期
                          </span>
                          <a-date-picker v-model="form.contractDate" ref="contractDate" />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                    <a-row :gutter="0">
                      <a-col span="12">
                        <a-form-model-item :colon="false" prop="fundAmount">
                          <span slot="label">
                            <i class="required-mark">*</i>
                            捐赠金额（元）
                          </span>
                          <!-- <a-input type="number" placeholder="捐赠金额（元）" allowClear v-model="form.fundAmount" ref="fundAmount" /> -->
                          <a-input-number
                            v-model="form.fundAmount"
                            style="margin: -0.3125rem 0; width: 400px"
                            :min="0"
                            :formatter="
                              value => {
                                let reg = /^(-)*(\d+)\.(\d\d).*$/
                                return `￥${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg, '$1$2.$3')
                              }
                            "
                            :parser="
                              value => {
                                let reg = /^(-)*(\d+)\.(\d\d).*$/
                                return value.replace(/\￥\s?|(,*)/g, '').replace(reg, '$1$2.$3')
                              }
                            "
                          ></a-input-number>
                        </a-form-model-item>
                      </a-col>
                      <a-col span="12">
                        <a-form-model-item :colon="false" prop="paymentDate">
                          <span slot="label">
                            <i class="required-mark">*</i>
                            实际到账日期
                          </span>
                          <a-date-picker v-model="form.paymentDate" ref="paymentDate" />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                    <!-- <a-row :gutter="0">
                      <a-col span="12">
                        <a-form-model-item :colon="false" prop="contacts">
                          <span slot="label">捐赠方联系人</span>
                          <a-input placeholder="捐赠方联系人" allowClear v-model="form.contacts" ref="contacts" />
                        </a-form-model-item>
                      </a-col>
                      <a-col span="12">
                        <a-form-model-item :colon="false" prop="telephone">
                          <span slot="label">捐赠方联系电话</span>
                          <a-input placeholder="捐赠方联系电话" allowClear v-model="form.telephone" ref="telephone" />
                        </a-form-model-item>
                      </a-col>
                    </a-row> -->
                    <a-row :gutter="0">
                      <a-col span="12">
                        <a-form-model-item :colon="false" prop="usages">
                          <span slot="label">
                            <i class="required-mark">*</i>
                            资金使用方向
                          </span>
                          <a-select v-model="form.usages" placeholder="请选择">
                            <a-select-option value="合作项目-公募合作">合作项目-公募合作</a-select-option>
                            <a-select-option value="合作项目-专项基金">合作项目-专项基金</a-select-option>
                            <a-select-option value="公益人才">公益人才</a-select-option>
                            <a-select-option value="精灵书屋">精灵书屋</a-select-option>
                            <a-select-option value="螺蛳壳改造">螺蛳壳改造</a-select-option>
                            <a-select-option value="爱心100">爱心100</a-select-option>
                            <a-select-option value="其他">其他</a-select-option>
                          </a-select>
                        </a-form-model-item>
                      </a-col>
                      <a-col span="12">
                        <a-form-model-item :colon="false" label="是否自动创建资金池">
                          <a-switch v-model="form.isCreatePoll" />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                    <a-row :gutter="0">
                      <a-col span="24">
                        <a-form-model-item :colon="false" prop="remarks" label="备注" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
                          <a-textarea v-model="form.remarks" placeholder="备注" :rows="4" style="width: 100%" />
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                    <a-row>
                      <a-col>
                        <a-form-item :colon="false" prop="fundlarge_resource" label="上传捐赠协议" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
                          <a-upload-dragger
                            :multiple="true"
                            :show-upload-list="{
                              showDownloadIcon: true,
                            }"
                            :action="`${baseURL}/fundlarge/file/upload`"
                            :data="{ params: JSON.stringify({ fileSign: 'fundlarge', fileType: 1 }) }"
                            @download="file => downloadFile(file.response.result)"
                            @change="handleUploadChange"
                          >
                            <div class="v-pa-xs">
                              <a-icon type="file-add" style="margin-bottom: 10px" />
                              <p class="font-xs">点击选择文件或拖拽文件至此区域</p>
                            </div>
                          </a-upload-dragger>
                        </a-form-item>
                      </a-col>
                    </a-row>
                  </div>
                </div>
              </a-form-model>

              <a-affix :offset-bottom="10" :target="() => this.$refs.container">
                <!-- <a-divider class="bg-gray"></a-divider> -->
                <div class="text-center">
                  <a-space>
                    <a-button icon="check" type="primary" :loading="saving" @click="handleSubmit">提交</a-button>
                    <a-button icon="undo" type="danger" @click="handleReset">重置</a-button>
                    <a-button icon="rollback" @click="$router.go(-1)">返回</a-button>
                  </a-space>
                </div>
              </a-affix>
            </div>
          </div>
        </template>
        <template v-else-if="currentStep == 1">
          <a-result status="success" title="大额捐赠添加成功">
            <template #extra>
              <a-button key="back" @click="$router.push('list')">返回列表</a-button>
            </template>
          </a-result>
        </template>
      </transition>
    </div>
  </div>
</template>

<script>
import { saveLargeFund, removeFile } from '@/api/capital'

export default {
  data() {
    return {
      currentStep: 0,
      form: {},
      saving: false,
      fileList: [],
    }
  },
  methods: {
    handleSubmit() {
      let { paymentName, fundAmount, contractDate, paymentDate, usages } = this.form
      this.$message.destroy()
      if (!paymentName) {
        this.$message.warning('请输入摘要')
        this.$refs.paymentName.focus()
        return
      }
      if (!fundAmount) {
        this.$message.warning('请输入捐赠协议金额')
        this.$refs.fundAmount.focus()
        return
      }
      if (!contractDate) {
        this.$message.warning('请选择协议日期')
        this.$refs.contractDate.focus()
        return
      }
      if (!paymentDate) {
        this.$message.warning('请选择实际到账日期')
        this.$refs.paymentDate.focus()
        return
      }
      if (!usages) {
        this.$message.warning('请选择资金使用方向')
        this.$refs.usages.focus()
        return
      }
      this.saving = true
      let param = { ...this.form }
      param.contractDate = this.$moment(this.form.contractDate).locale('zh-cn').format('YYYY-MM-DD')
      param.paymentDate = this.$moment(this.form.paymentDate).locale('zh-cn').format('YYYY-MM-DD')
      param.fileIds = this.fileList.map(file => file.response.result.fileId)
      saveLargeFund(param)
        .then(({ data }) => {
          if (data.success) {
            this.$message.success('操作成功')
            this.id = data.result
            this.currentStep = 1
          } else {
            this.$message.error('操作失败')
          }
          this.saving = false
        })
        .catch(() => {
          this.saving = false
          this.$message.error('操作失败')
        })
    },
    handleUploadChange({ file, fileList }) {
      if (file.status === 'done') {
        this.fileList = [...fileList]
      } else if (file.status === 'removed') {
        this.fileList = [...fileList]
        let fileId = file.response.result.fileId
        removeFile({ fileId })
      }
    },
    handleReset() {
      this.form = {}
      this.id = null
    },
  },
  mounted() {},
}
</script>

<style scoped>
.ant-transfer-list {
  width: 500px !important;
  height: 580px !important;
}
.ant-tag-green {
  color: #55a027;
  background: #f6ffed;
  border-color: #55a027;
}
.ant-tag-blue {
  color: #1777ff;
  background: #e6f7ff;
  border-color: #1777ff;
}
</style>
